import * as React from "react";
import { NavLink } from "react-router-dom";
import cx from "classcat";
import {
  MdDashboard,
  MdBusiness,
  MdGroup,
  MdInsertChart,
  MdEmail,
  MdEventNote,
} from "react-icons/md";
import { FaStackOverflow } from "react-icons/fa";
import { IoMdGitNetwork } from "react-icons/io";
import { useUser } from "../useUser";
import { useSelectedOrganizationUuid } from "../useSelectedOrganizationUuid";
import styles from "./Sidebar.module.css";

export default function Sidebar() {
  const { user } = useUser();
  const { selectedOrganizationUuid } = useSelectedOrganizationUuid();

  return (
    <div className={styles.sidebar}>
      <nav className={styles.nav}>
        <ul className={styles.nav_list}>
          {getLinks(user.selectedRole, selectedOrganizationUuid).map((x, i) => {
            const Icon = x.icon;
            return (
              <li key={i}>
                <NavLink
                  exact
                  to={x.to}
                  className={cx([
                    styles.nav_link,
                  ])}
                  activeClassName={styles.nav_link_active}
                >
                  <Icon aria-hidden="true" className={styles.nav_link_icon} />
                </NavLink>
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
}

export function getLinks(role: string, selectedOrganizationUuid: string) {
  return [
    {
      text: "Dashboard",
      to: "/home",
      icon: MdDashboard,
    },
    {
      text: "Clients",
      to: "/clients",
      icon: IoMdGitNetwork,
    },
    {
      text: "Organization",
      to: `/organizations/${selectedOrganizationUuid}`,
      icon: MdBusiness,
    },
    {
      text: "Users",
      to: `/organizations/${selectedOrganizationUuid}/users`,
      icon: MdGroup,
    },
    {
      text: "DIS Metrics",
      to: "/dis-metrics",
      icon: MdInsertChart,
    },
    {
      text: "Email Interface",
      to: "/email-interface",
      icon: MdEmail,
    },
    {
      text: "Attacks",
      to: "/attacks",
      icon: FaStackOverflow,
    },
    {
      text: "Event Logger",
      to: "/select-event-logger",
      icon: MdEventNote,
    },
  ];
}
